import axios from 'axios';

export const enumStatusCommand = {
    VALIDATE_BIA: 'ValidateBiaCommand',
    CANCEL_AFFILIE: 'RemoveAffilieByNumSecuCommand',
};

export function getCommand(listCles, listActions) {
    return axios.get(`/statusCommand`, { params: { listCles, listActions } });
}

export function getBiaById(id) {
    return axios.get(`/bia/${id}`);
}
